import styled, {
  breakpoints,
  css,
  Device,
  FlattenSimpleInterpolation,
  IFalconTheme,
  IFalconThemeProps,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  Scale,
  StyledComponent,
  typographyVariantProperties,
} from '@se-admin/falcon';
import { SaleCardVariant } from '../SaleCard.interfaces';
import { Color } from './../../../common/types/color';

export const DestinationWrapper: StyledComponent<
  'div',
  IFalconTheme,
  { saleCardVariant: SaleCardVariant }
> = styled('div')(
  ({ saleCardVariant, theme }: { saleCardVariant: SaleCardVariant } & IFalconThemeProps) => {
    return css`
      display: flex;
      font-size: ${typographyVariantProperties[ResponsiveTypographyVariant.body].desktopFontSize};
      color: ${theme.color.blackText};
      margin-bottom: ${saleCardVariant === SaleCardVariant.normal ? '0' : Scale.xxxs};
    `;
  }
);

export const DestinationText: StyledComponent<
  typeof ResponsiveTypography,
  IFalconTheme,
  { saleCardVariant: SaleCardVariant }
> = styled(ResponsiveTypography)(
  ({ saleCardVariant }: { saleCardVariant: SaleCardVariant } & typeof ResponsiveTypography) => {
    return css`
      display: inline;

      ${SaleCardVariant.small === saleCardVariant
        ? `display: block;
        display: -webkit-box;
        overflow: hidden;
        line-height: 1.5em;
        max-height: 1.5em;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        `
        : `
          padding-right: ${Scale.xl}
        `}
    `;
  }
);

export const descriptionStyle: FlattenSimpleInterpolation = css`
  display: inline;

  margin-bottom: ${Scale.xs};

  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    display: block;
    margin-bottom: 0;
  }
`;

export const peopleViewingStyle: FlattenSimpleInterpolation = css`
  && {
    margin-bottom: ${Scale.xxxs};
  }

  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
  }
`;

export const bookingsMadeStyle: FlattenSimpleInterpolation = css`
  color: ${Color.red};

  && {
    margin-bottom: ${Scale.xs};
  }

  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
  }
`;

export const SaleTitle: StyledComponent<
  typeof ResponsiveTypography,
  IFalconTheme,
  { saleCardVariant: SaleCardVariant }
> = styled(ResponsiveTypography)`
  display: block;

  && {
    font-weight: 600;
  }

  ${({
    saleCardVariant,
  }: { saleCardVariant: SaleCardVariant } & IFalconTheme & typeof ResponsiveTypography) =>
    SaleCardVariant.normal === saleCardVariant
      ? `
        margin-bottom: 0;

        &:after {
          content: ' • ';
        }

        @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
          display: block;
          line-height: 1.25em;
          margin-bottom: ${Scale.s};
          &:after {
            content: none;
          }
          && {
            font-size: ${
              typographyVariantProperties[ResponsiveTypographyVariant.t5Sans].desktopFontSize
            };
          }
        }
      `
      : `
          display: block;
          display: -webkit-box;
          overflow: hidden;
          line-height: 1.25em;
          height: 2.5em;
          line-clamp: 2;
          box-orient: vertical;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        `}
`;
